import React, { useState, useContext, useEffect } from "react";

import {
  Notification,
  FormGroup
} from "xsolla-uikit";

export default function DistributionBlocker ({
  enabled = false,
  webhooksNeeded = false,
  webhooksEnabled = false,
  agreement = false,
  handleCurrentState = ()=>{void(0)}
 }) {

    // const [state, setstate] = useState({...useContext(KeyContext), ...useContext(GlobalContext)})
    // console.log('state = ', state);


    return (
      <React.Fragment>
        {/* {((webhooksNeeded && !webhooksEnabled) || !agreement) && ( */}
          <FormGroup indentation="xs">
            <Notification
              status="warning"
              icon={true}
              // title="To start selling"
              style={{ width: "100%" }}
            >
              {!enabled && (
                <FormGroup indentation="xs">
                  <a href="#">Finish setting up the game keys package</a>
                </FormGroup>
              )}

              {webhooksNeeded && !webhooksEnabled && (
                <FormGroup indentation="xs">
                  <a
                    // onClick={e => {
                    //   handleCurrentState("globalWebhooks", {
                    //     ...state.globalState.globalWebhooks,
                    //     value: true
                    //   });
                    // }}
                  >
                    Set up webhooks
                  </a>
                </FormGroup>
              )}

              {!agreement && (
                <FormGroup indentation="xs">
                  <a
                    // onClick={e => {
                    //   state.handleCurrentState("globalAgreement", {
                    //     value: true
                    //   });
                    // }}
                  >
                    Sign licensing agreement
                  </a>
                </FormGroup>
              )}
            </Notification>
          </FormGroup>
        {/* )} */}
      </React.Fragment>
    );
  };
